import { Column, ColumnBodyOptions } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { CSSProperties, useMemo, useState } from 'react';
import {
  PaymentType,
  SettingsLecturersRateType,
} from '../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { AddNewRateTypeDialog } from './components/add-new-rate-type-dialog';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import { deleteLecturerRateOperation } from './operations/delete-lecturer-rate-operation';

export const SettingsLecturerRatePriceTypes = observer(() => {
  const [addDialog, setAddDialog] = useState(false);
  const [editRate, setEditRate] = useState<SettingsLecturersRateType | null>(
    null,
  );
  const [loading, setLoading] = useState(false);
  const [selectedRates, setSelectedRates] = useState<
    SettingsLecturersRateType[]
  >([]);
  const [deleteRateId, setDeleteRateId] = useState<number | null>(null);

  const cellStyle = { textAlign: 'right' } as CSSProperties;

  const dialogHide = () => setAddDialog(false);

  const handleEditRate = (rate: SettingsLecturersRateType) => {
    setEditRate(rate);
  };

  const handleDeleteRate = async (rate: SettingsLecturersRateType) => {
    await deleteLecturerRateOperation(rate.id, setDeleteRateId);
  };

  const handleSaveRate = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.LECTURER_RATE,
      id,
      newName,
      setLoading,
    );
  };

  const lecturersTypeRateNames = useMemo(() => {
    return globalSettingsStores.lecturersTypeRateNames;
  }, [globalSettingsStores.lecturersTypeRateNames]);

  return (
    <div>
      <Dialog
        header="הוספת סוג תשלום שעתי עבור מרצה"
        visible={addDialog}
        onHide={dialogHide}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddNewRateTypeDialog closeDialog={dialogHide} />
      </Dialog>

      <EditTextDialog
        id={editRate?.id}
        value={editRate?.typeRateName}
        title="עריכת סוג תשלום"
        label="שם סוג התשלום"
        loading={loading}
        onSave={handleSaveRate}
        onHide={() => setEditRate(null)}
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <div style={{ maxWidth: '45px', marginRight: '8px' }}>
          <Button
            style={{ height: '30px' }}
            label={'הוספה'}
            onClick={() => setAddDialog(true)}
          />
        </div>
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedRates}
        onSelectionChange={(e) => setSelectedRates(e.value)}
        value={lecturersTypeRateNames}
      >
        <Column style={cellStyle} field="typeRateName" header="סוג פעילות" />

        <Column
          style={cellStyle}
          field="paymentType"
          body={(
            data: SettingsLecturersRateType,
            options: ColumnBodyOptions,
          ) => (
            <div>
              {data.paymentType === PaymentType.Hourly
                ? 'שעה עגולה (60 דקות)'
                : 'שעה אקדמית (45 דקות)'}
            </div>
          )}
          header="מנת מדידה"
        />
        <Column style={cellStyle} field="createdByName" header="נוצר ע״י" />
        <Column
          style={cellStyle}
          field="createAt"
          header="תאריך יצירה"
          body={(rowData) =>
            rowData.createdAt
              ? new Date(rowData.createdAt).toLocaleDateString('he-IL')
              : ''
          }
        />
        <Column
          style={cellStyle}
          field="פעולות"
          header=""
          body={(data: SettingsLecturersRateType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סוג תשלום'}
                onClick={() => handleEditRate(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סוג תשלום'}
                loading={deleteRateId === data.id}
                disabled={deleteRateId !== null}
                onClick={() => handleDeleteRate(data)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
